import { useTheme } from "@mui/material";
import { useMemo } from "react";
import { createEditorTheme } from "../createEditorTheme.js";
import { getDefaultEditorTheme } from "../getDefaultEditorTheme.js";
function useEditorTheme(editorThemeStyles) {
  const theme = useTheme();
  return useMemo(() => createEditorTheme(editorThemeStyles, getDefaultEditorTheme(theme)), [editorThemeStyles, theme]);
}
export {
  useEditorTheme
};
//# sourceMappingURL=useEditorTheme.js.map
